import { Component, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CraneListService, Crane } from "../../services/craneListService";
import { Router } from "@angular/router";
import { AppStateService } from "../../services/appState.service";

@Component({
  selector: "app-crane-selection",
  templateUrl: "./craneSelection.component.html",
  styleUrls: [
    "./craneSelection.component.css",
    "../../allgemeinesTS_CSS/tooltip.css",
    "../../allgemeinesTS_CSS/cssButton.css",
  ],
  providers: [CraneListService],
})
export class CraneSelectionComponent implements OnInit {
  craneSelectionForm: FormGroup;
  public einheitenSystem = "M";
  public kranBerechnungsArt = "0";
  public groesseKranAuswahl = 3;
  cranes: Crane[];
  noCraneSelected = true;
  public falscherTabellenTyp = false;
  protected appStatus: Object = {};
  submitted = false;
  constructor(
    private fb: FormBuilder,
    private craneListService: CraneListService,
    private router: Router,
    private appStateService: AppStateService
  ) {}

  ngOnInit(): void {
    this.craneSelectionForm = this.fb.group({
      systemOfUnit: [this.einheitenSystem],
      Berechnungsart: [this.kranBerechnungsArt],
      craneModel: ["", Validators.required],
    });
    this.appStateService.appStatusVonServerHolen().then((res) => {
      if (res["loginStatus"] !== "loggedIn") {
        this.router.navigate(["/"]);
      }
      this.appStateService.appStatusSetzen({
        aktuellerMenuePunkt: "CraneSelection",
        PrintOut: "inactive",
      });
      if (
        this.appStateService.aktuellerAppStatus["einheitenSystem"] !==
          undefined &&
        this.appStateService.aktuellerAppStatus["einheitenSystem"] !== ""
      ) {
        this.einheitenSystem =
          this.appStateService.aktuellerAppStatus["einheitenSystem"];
        this.craneSelectionForm
          .get("systemOfUnit")
          .setValue(this.einheitenSystem);
      }
      if (
        this.appStateService.aktuellerAppStatus["kranBerechnungsArt"] !==
          undefined &&
        this.appStateService.aktuellerAppStatus["kranBerechnungsArt"] !== ""
      ) {
        this.kranBerechnungsArt =
          this.appStateService.aktuellerAppStatus["kranBerechnungsArt"];
        this.craneSelectionForm
          .get("Berechnungsart")
          .setValue(this.kranBerechnungsArt);
      }
      this.craneListService
        .getCraneList()
        .then((res1) => this.createCraneList(res1));
    });
    this.appStateService.appStatus$.subscribe((res) => {
      this.appStatus = res;
      this.setzeKranDatenbankNamen(res["kranDatenbankNamen"]);
    });
  }
  setzeKranDatenbankNamen(dbName: string) {
    this.craneSelectionForm.value.craneModel = dbName;
  }
  createCraneList(craneList) {
    let addCrane: boolean;
    let newCrane: Crane;
    this.cranes = [];
    craneList.forEach((tempCrane) => {
      addCrane = true;
      newCrane = new Crane(
        tempCrane["Datenbank"],
        tempCrane["Krannamen"],
        tempCrane["Einheit"],
        tempCrane["TabellenTyp"],
        tempCrane["Hersteller"],
        tempCrane["abstuetzVarianten"],
        tempCrane["anzahlAbstuetzPositionen"]
      );
      if (
        newCrane.massSystem !==
          String(this.craneSelectionForm.value["systemOfUnit"]) ||
        !this.hatKranPassendenTabellenTyp(
          newCrane,
          this.craneSelectionForm.value["Berechnungsart"]
        )
      ) {
        addCrane = false;
      }
      if (addCrane === true) {
        // Position suchen, damit Krannamen unabhängig vom Datenbanknamen richtig nach Namen sortiert werden.
        let i = 0;
        for (const kran of this.cranes) {
          if (newCrane.name < kran.name) {
            break;
          }
          i++;
        }
        this.cranes.splice(i, 0, newCrane);
      }
    });
    // Kranliste alphabetisch sortieren

    // Größe des Auswahlfelds berechnen
    this.groesseKranAuswahl = Math.max(
      3,
      Math.min(Math.round(this.cranes.length / 2) + 1, 20)
    );
  }

  hatKranPassendenTabellenTyp(kran: Crane, gewuenschterTabellentyp: string) {
    let passendeTabellenTypen: string;
    switch (gewuenschterTabellentyp) {
      case "0":
      case "1":
        passendeTabellenTypen = "|0|1|4|";
        break;
      case "2":
        passendeTabellenTypen = "|2|";
        break;
      case "4":
        passendeTabellenTypen = "|4|";
        break;
      default:
        break;
    }
    return passendeTabellenTypen.indexOf("|" + kran.tabellenTyp + "|") > -1
      ? 1
      : 0;
  }
  aendereEinheitenSystem(typ: string) {
    this.einheitenSystem = typ;
    this.appStateService.appStatusSetzen({
      einheitenSystem: this.einheitenSystem,
    });
    this.aendereKranListe();
  }
  aendereKranListe() {
    this.craneListService
      .getCraneList()
      .then((res) => this.createCraneList(res));
    this.craneSelectionForm.get("craneModel").setValue("");
  }
  aendereKranArt() {
    this.appStateService.appStatusSetzen({
      kranBerechnungsArt: this.kranBerechnungsArt,
    });
    this.aendereKranListe();
  }
  pruefeKranAuswahl() {
    if (this.craneSelectionForm.value.craneModel !== "") {
      if (
        this.appStateService.aktuellerAppStatus["kranDatenbankNamen"] !==
        this.craneSelectionForm.value.craneModel
      ) {
        // neuer Kran gewählt, daher alle relevanten Einstellungen zurücksetzten bzw. den Appstatus resetten,
        // so dass nur noch richtige Sache drinnen stehen.
        this.appStateService.appStatusReset({
          loginStatus: "loggedIn",
          Login: "active",
          CraneSelection: "active",
          CraneSetup: "active",
          CraneControl: "inactive",
          PrintOut: "inactive",
          aktuellerMenuePunkt: "CraneSelection",
          EMail: this.appStateService.aktuellerAppStatus["EMail"],
          kranBerechnungsArt: this.craneSelectionForm.value.Berechnungsart,
          einheitenSystem:
            this.appStateService.aktuellerAppStatus["einheitenSystem"],
          kranDatenbankNamen: this.craneSelectionForm.value.craneModel,
        });
        this.craneListService.zerstoereKran();
      }
      this.noCraneSelected = false;
    } else {
      this.noCraneSelected = true;
    }
  }

  goBack() {
    history.back();
  }

  onSubmit() {
    this.pruefeKranAuswahl();
    this.submitted = true;
    if (this.craneSelectionForm.value.craneModel !== "") {
      this.noCraneSelected = false;
      let tempKranname: string;
      let tempAbstuetzVarianten = 0;
      let tempAnzahlAbstuetzPositionen = -1;
      for (const temp of this.cranes) {
        if (temp["datenbank"] === this.craneSelectionForm.value.craneModel) {
          tempKranname = temp["name"];
          tempAbstuetzVarianten = temp["abstuetzVarianten"];
          tempAnzahlAbstuetzPositionen = temp["anzahlAbstuetzPositionen"];
          break;
        }
      }
      // this.appStateService.appStatusSetzen({ anzahlAbstuetzPositionen: tempAnzahlAbstuetzPositionen });
      switch (this.craneSelectionForm.value.Berechnungsart) {
        case "0": // standard, bekannte Traglasttabellen
          this.falscherTabellenTyp = false;
          this.appStateService.appStatusSetzen({
            kranname: tempKranname,
            kranDatenbankNamen: this.craneSelectionForm.value.craneModel,
            einheitenSystem: this.einheitenSystem,
            CraneSetupMenu: "standardTabellenSetup",
            CraneControlMenu: "control360Table",
            anzahlAbstuetzPositionen: tempAnzahlAbstuetzPositionen,
          });
          this.appStateService.meuePunktStatusSetzen({ CraneSetup: "active" });
          this.router.navigate(["standardTabellenSetup"]);
          break;
        case "1": // interpoliert, wie eine Traglasttabelle, aber selbst berechnet
          this.falscherTabellenTyp = true;
          break;
        case "2": // maxBase, Aufteilung des 360° Drehbereiches in 4 Segmente (vorne, hinten, rechts, links) mit eigenen Traglastgrenzen
          this.falscherTabellenTyp = false;
          const abstuetzVarianten = tempAbstuetzVarianten;
          this.appStateService.appStatusSetzen({
            kranname: tempKranname,
            kranDatenbankNamen: this.craneSelectionForm.value.craneModel,
            einheitenSystem: this.einheitenSystem,
            CraneSetupMenu: "maxBaseSetup",
            CraneControlMenu: "controlMaxBase",
            abstuetzVarianten: abstuetzVarianten,
            anzahlAbstuetzPositionen: tempAnzahlAbstuetzPositionen,
          });
          const menueStartStatus: Object = {
            CraneSetup: "active",
          };
          this.appStateService.meuePunktStatusSetzen(menueStartStatus);
          this.router.navigate(["maxBaseSetup"]);
          break;
        case "3": // wie MaxBase, aber mit Unterteilung in n Segmente
          this.falscherTabellenTyp = true;
          break;
        case "4": // asymmTerex, Berechnet ein 360 x 360 Punkte-Raster zur Darstellung in einem Kreis
          this.falscherTabellenTyp = true;
          break;
        case "5": // asymmBoecker, Traglastgrenzen werden anhand von vorgegebenen Auslegermomenten auf 360° gerechnet
          this.falscherTabellenTyp = true;
          break;
        case "6": // artikulation, Knicklenker mit verschiedenen Artikulationswinkeln und zugehörigen Traglastgrenzen
          this.falscherTabellenTyp = true;
          break;
        case "7": // artikulationinterpoliert, wie Artikulation, aber selbst berechnet
          this.falscherTabellenTyp = true;
          break;
        case "8": // herstellerInterface, Traglastgrenzen und ggf. mehr werden von einem Interface zu Daten des Herstellers
          // ausgelesen bzw. berechnet
          this.falscherTabellenTyp = true;
          break;
      }
    } else {
      this.noCraneSelected = true;
    }
  }
}
